export default __webpack_public_path__ + "static/media/meihao.427a74b2.ico";